const TONES: Record<string, string> = {
  ACTIVE: 'bg-green-100 text-green-800',
  FINISHED: 'bg-slate-200 text-slate-700',
  SCHEDULED: 'bg-amber-100 text-amber-800',
  issued: 'bg-blue-100 text-blue-800',
  redeemed: 'bg-green-100 text-green-800',
};

export function Badge({ value }: { value: string | null }) {
  if (!value) return <span className="text-slate-400">–</span>;
  const tone = TONES[value] ?? 'bg-slate-100 text-slate-700';
  return (
    <span className={`inline-block rounded px-2 py-0.5 text-xs font-semibold ${tone}`}>{value.toLowerCase()}</span>
  );
}
